// extracted by mini-css-extract-plugin
export default {"root":"Copyright_root__AfOLo"};